export { default } from './ConfirmPersonalInfoDuringSignUp.container';
export { default as ConfirmPersonalInfoDuringActivate } from './ConfirmPersonalInfoDuringActivate.container';
